import { FC } from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceLine,
} from 'recharts';
import dayjs from 'dayjs';
import { ILoadAtInjuryMetric } from '../../../../models/injury';
import { ChartEmptyState } from './_shared/ChartEmptyState';
import {
  chartAxisTick,
  chartGridProps,
  chartTooltipContentStyle,
  chartTooltipItemStyle,
  chartTooltipLabelStyle,
} from '../../../../shared/charts/chartTheme';

interface Props {
  data: ILoadAtInjuryMetric | null;
  period?: string;
  height?: number;
}

export const LoadAtInjuryChart: FC<Props> = ({ data, height }) => {
  if (!data || !data.events || data.events.length === 0) {
    return <ChartEmptyState />;
  }

  return (
    <ResponsiveContainer width="100%" height={height ?? 220}>
      <BarChart data={data.events} margin={{ top: 4, right: 16, left: 0, bottom: 0 }}>
        <CartesianGrid {...chartGridProps} />
        <XAxis dataKey="date" tickFormatter={(v) => dayjs(v).format('DD/MM')} tick={chartAxisTick} />
        <YAxis tick={chartAxisTick} />
        <Tooltip
          contentStyle={chartTooltipContentStyle}
          labelStyle={chartTooltipLabelStyle}
          itemStyle={chartTooltipItemStyle}
          formatter={(_value, _name, props) => {
            const { date, acwr, weeklyLoad } = props.payload;
            return [`ACWR: ${acwr?.toFixed(2)} | Carico: ${weeklyLoad ?? '—'}`, dayjs(date).format('DD/MM/YYYY')];
          }}
        />
        <ReferenceLine
          y={1.3}
          stroke="var(--ri-warning)"
          strokeDasharray="4 3"
          label={{ value: 'Rischio', fontSize: 10, fill: 'var(--ri-warning)', position: 'right' }}
        />
        <ReferenceLine
          y={0.8}
          stroke="var(--ri-good)"
          strokeDasharray="4 3"
          label={{ value: 'Sicuro', fontSize: 10, fill: 'var(--ri-good)', position: 'right' }}
        />
        <Bar dataKey="acwr" fill="var(--ri-critical)" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};
